export default __webpack_public_path__ + "static/illustration-sm-219098f6e86ba3c08b8b807ebc78103d.svg";